<template>

<div id="listing-card-page" class="user-mh-100">
    <div class="mb-0"></div>
    <section id="listing-product-panel">
        <div class="wrapper">
            <div class="content tab-content pt-0">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">

                    <div class="wrapper mt-3">

                        <div class="title-section alert alert-secondary p-1 shadow-sm container mb-3" v-if="$page.props.trending_update_remaining_time">
                            <div class='trending-products p-2'>
                                <p v-html="$page.props.trending_update_remaining_time"></p>
                            </div>
                        </div>

                        <form action="" method="post" @submit.prevent="submit">
                            <div class="row p-2">

                                <!-- date -->
                                <div class="col-md-3 mb-3">
                                    <label for="klf_date">Date</label>
                                    <DateRangePicker :minDate="$page.props.data.endDate" id="klf_date" name="date" v-model="f.date" class="form-control" title="Date"/>
                                </div>

                                <!-- country -->
                                <div class="col-md-6 mb-3">
                                    <label for="klf_country">Country</label>
                                    <Multiselect name="country" id="klf_country"
                                                 value-prop="code" trackBy="title" label="title" mode="multiple"
                                                 placeholder="Select Country"
                                                 v-model="f.country" :options="data.countries"
                                                 @select="countryFilterSelected">
                                        <template v-slot:multiplelabel="{ values }">
                                            <div class="multiselect-multiple-label">
                                                {{
                                                    values.length > 4 ? values.length + " options selected" : values.map((c) => c.title).join(", ")
                                                }}
                                            </div>
                                        </template>
                                    </Multiselect>
                                </div>

                                <!-- sorting -->
                                <div class="col-md-3 mb-3">
                                    <label for="klf_sortby">Sort By</label>
                                    <select id="klf_sortby" name="sortby" v-model="f.sortby" class="form-select" title="Sort By" >
                                        <option :value="i" v-for="(v,i) in data.sortList">{{ v }}</option>
                                    </select>
                                </div>

                                <!-- sorting -->
                                <div :class="'col-md-3 mb-3'">
                                    <template v-if="$page.props.data.keywordFilters.length == 0">
                                        <a :href="routes.keyword_filter" class="btn btn-danger text-white mt-3">Add New Filters</a>
                                    </template>
                                    <template v-else>
                                        <label for="klf_filter" class="w-100 d-inline-block">
                                            Load Filters
                                            <span><a :href="routes.keyword_filter" class="btn btn-link p-0 float-end">Add New</a></span>
                                        </label>
                                        <select id="klf_filter" name="filter" class="form-select" title="Filters" @change="keywordFilterSelected($event)">
                                            <option value="">Select Filter</option>
                                            <option :value="v.id" v-for="(v,i) in $page.props.data.keywordFilters" :key="i">{{ v.name }}</option>
                                        </select>
                                    </template>
                                </div>

                                <!-- keywords -->
                                <div class="col-md-9 mb-3">
                                    <label for="klf_keyword">Exact Keywords</label>
                                    <input type="text" id="klf_keyword" name="name" v-model="f.keyword" class="form-control" placeholder="Use comma separated keywords for bulk addition" title="Exact Keywords">
                                </div>

                                <!-- keywords -->
                                <div class="col-md-6 mb-3">
                                    <label for="klf_keyword_phrasal">Phrasal Keywords</label>
                                    <input type="text" id="klf_keyword_phrasal" name="name" v-model="f.keyword_phrasal" class="form-control" placeholder="Use comma separated keywords for bulk addition" title="Phrasal Keywords">
                                </div>

                                <!-- keywords negative -->
                                <div class="col-md-6 mb-3">
                                    <label for="klf_keyword_negative">Negative Keywords</label>
                                    <input type="text" id="klf_keyword_negative" name="keyword_negative" v-model="f.keyword_negative" class="form-control" placeholder="Use comma separated keywords for bulk addition" title="Negative Keywords">
                                </div>

                                <div class="col-md-12 mb-3">
                                    <div class="float-end">
                                        <st-button @clicked="showExport" type="button" title="Export" class-name="btn btn-primary mr5" icon="fa fa-download" :disable="loading" />
                                        <st-button @clicked="resetFilter" type="button" title="Reset Filters" class-name="btn btn-warning mr5" icon="fa fa-sync" :disable="loading" />
                                        <st-button type="submit" title="Search" class-name="btn btn-primary" icon="fa fa-filter" :disable="loading" />
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div class="wrapper mt-3">
                        <PageLoading :loading="loading" />
                        <h6 class="mb-3" v-if="haveRecord">{{ recordInfo }}</h6>
                        <template v-if="haveRecord">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Keyword</th>
                                            <th>Rating</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="v in keywords.data" :key="v.id">
                                            <td>
                                                <span class="text-capitalize"><strong>{{ v.keyword }}</strong></span> <br>
                                                <span class="small" style="font-size: 14px;">Trend Capture on {{ v.created_format }}</span>
                                            </td>
                                            <td>{{ v.rating }}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="container table-responsive mt-4">
                                <pagination class-name="justify-content-center flex-wrap" :links="keywords.links"></pagination>
                            </div>
                        </template>
                        <template v-else>
                            <div class="mt-5 mb-5">
                                <RecordNotFound />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- export modal -->
        <div class="modal" tabindex="-1" :id="exp.modalId">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label for="exp_exp_type">File Type</label>
                                <select id="exp_exp_type"  v-model="exp.form.export_type" class="form-control" title="File Type">
                                    <option value="csv">Csv</option>
                                    <option value="txt">Text</option>
                                    <option value="xlsx">Excel</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label for="exp_exp_rating">Hide Rating</label>
                                <select id="exp_exp_rating"  v-model="exp.form.export_rating" class="form-control" title="Hide Rating">
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label for="exp_exp_limit">Limit</label>
                                <select id="exp_exp_limit"  v-model="exp.form.export_limit" class="form-control" title="Limit">
                                    <option value="current">Current Page</option>
                                    <option value="100">100</option>
                                    <option value="150" >150</option>
                                    <option value="200" >250</option>
                                    <option value="500" >500</option>
                                    <option value="1000" >1000</option>
                                    <option value="2000" >2000</option>
                                    <option value="all" >All</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn grey btn-sm btn-outline-secondary" data-bs-dismiss="modal">Close</button>
                        <button @click="exportData" type="button" class="btn grey btn-sm btn-outline-primary" >Export</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- export end modal -->
    </section>
</div>
</template>
<script>

import RecordNotFound from "@s/Components/RecordNotFound";
import Pagination from "@s/Components/Inertia/IPagination";
import PageLoading from "@u/Pages/Product/components/PageLoading";
import DateRangePicker from "../../../shared/Components/DateRangePicker";
import StButton from "../../../shared/Components/Buttons/StButton";
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css';

export default {
    name: 'KeywordList',
    components: {
        DateRangePicker,
        PageLoading,
        'pagination': Pagination,
        RecordNotFound,
        StButton,
        Multiselect
    },
    props: ["keywords", "data", "filters", "date", "pageTitle", "recordInfo"],
    data() {
      return {
          loading: false,
          f: {... this.filters},
          routes: __st.routes,
          dateTitle: 'Date',
          dateOptions: {
              ranges: {
                  'Today': [moment(), moment()],
                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'Last 10 Days': [moment().subtract(9, 'days'), moment()],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
              }
          },
          exp: {
              modalId:  'trending-export-modal',
              form: {
                  export_rating: 0,
                  export_type: 'csv',
                  export_limit: 'current',
              }
          }
      }
    },
    computed: {
        haveRecord() {
            return this.keywords.data.length > 0;
        }
    },

    created() {

        document.title = this.pageTitle;
        if(this.date.startDate) {
            this.dateOptions.startDate = this.date.startDate;
        }
        if(this.date.endDate) {
            this.dateOptions.endDate = this.date.endDate;
        }


    },
    methods: {
        submit() {
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                if(key == 'country') {
                    return key + '=' + that.f[key].join(",")
                }
                return key + '=' + that.f[key]
            }).join('&');
            const url = this.data.currentUrl+"?"+queryString;
            this.$inertia.visit(url, {
                    only: ['keywords',"filters", "date", "recordInfo"],
                onStart: (visit) => { this.loading = true },
                onFinish: (visit) => { this.loading = false },
            },
            )
        },

        resetFilter() {
            let filters = Object.assign({}, this.filters);
            filters.date = '';
            filters.country = [-1];
            filters.keyword = '';
            filters.keyword_negative = '';
            filters.sortby = 'hrating';
            this.f = filters;
        },

        countryFilterSelected() {
            if(this.f.country.length > 1) {
                this.f.country = this.f.country.filter((c) => c != "-1");
            }
        },

        keywordFilterSelected(e) {

            let filterId = e.target.value;

            if(! filterId) {
                return ;
            }

            let filter = this.$page.props.data.keywordFilters.find((k) => k.id == filterId);
            if(filter)
            {
                this.f.keyword = filter.payload.keyword;
                this.f.keyword_negative = filter.payload.keyword_negative;
                this.f.keyword_phrasal = filter.payload.keyword_phrasal;
                this.f.sortby = filter.payload.sortby;
                this.f.country = filter.payload.country || [-1];
            }

        },


        showExport() {
            (new bootstrap.Modal(document.getElementById(this.exp.modalId))).show();
        },

        exportData(){
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                if(key == 'country') {
                    return key + '=' + that.f[key].join(",")
                }
                return key + '=' + that.f[key]
            }).join('&');

            let exportLimit = this.exp.form.export_limit;
            let extra_query = "&export=1&export_type="+this.exp.form.export_type+"&export_limit="+exportLimit+"&export_rating="+this.exp.form.export_rating;
            let url = '';
            if(exportLimit == 'current' || exportLimit == 'all')
            {
                url = this.keywords.links.find((p) => p.active)?.url + extra_query;
            }
            else
            {
                url = this.keywords.links.find((p) => p.active)?.url + extra_query;
            }

            if(url)
            {
                location.href = url;
                const modal = bootstrap.Modal.getInstance(document.getElementById(this.exp.modalId))
                modal.hide();
            }

            //let url = this.data.currentUrl+"?"+queryString+"&export=1&export_type="+this.exp.form.export_type+"&export_limit="+exportLimit+"&export_rating="+this.exp.form.export_rating + extra_query;



        },

    }
}
</script>

<style>
[v-cloak] { display:none; }
</style>

